import React from 'react';
import {
    Dialog,
    DialogContent,
    Typography,
    Button,
    Box,
    IconButton,
    Paper,
    CircularProgress
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaymentStatusPopup from './PaymentStatusPopup';

const PaymentSuccessPopup = ({
    open,
    onClose,
    expiry_date,
    title = "Payment Successful",
    subtitle,
    // Actions,
    Icon,
    iconStyles = {}, // Custom icon styles
    // ActionText = "Close",
    Actions = () => {
        return <></>
    },
    isLoading = false
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    maxWidth: { xs: '300px', sm: '400px' },
                    width: '100%',
                    boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.1)',
                    position: 'relative',
                    p: 2
                }
            }}
        >
            <DialogContent sx={{ p: 2, textAlign: 'center' }}>
                <PaymentStatusPopup isLoading={isLoading} Icon={Icon} subtitle={subtitle} title={title} Actions={Actions} iconStyles={iconStyles} />
            </DialogContent>
        </Dialog>
    );
};

export default PaymentSuccessPopup;

// Usage example:
// function App() {
//   const [open, setOpen] = React.useState(true);
//   const handleClose = () => setOpen(false);
//
//   return (
//     <PaymentSuccessPopup open={open} onClose={handleClose} />
//   );
// }